var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "ul",
    _vm._l(_vm.listData.items, function(item) {
      return _c("li", [
        _c("p", { staticClass: "text-medium black" }, [
          _vm._v(" " + _vm._s(item.text))
        ]),
        _c(
          "div",
          { staticClass: "item__actions" },
          _vm._l(item.actions, function(action) {
            return _c(
              "span",
              [_c("svgicon", { attrs: { icon: action.icon, height: "18" } })],
              1
            )
          }),
          0
        )
      ])
    }),
    0
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }